import React from "react";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";

const MaskTransactionItem = ({
  transactions,
  onEdit,
  onDelete,
  onDownload,
  onReturn,
}) => {
  const getActivityBadge = (activity) => {
    switch (activity) {
      case "Borrow":
        return <Badge bg="primary">Borrow</Badge>;
      case "Rent":
        return <Badge bg="success">Rent</Badge>;
      case "Return":
        return <Badge bg="info">Return</Badge>;
      default:
        return <Badge bg="secondary">{activity}</Badge>;
    }
  };

  const getStatusBadge = (isReturned, activity, hasActiveItems) => {
    if (activity === "Return") {
      return <Badge bg="success">Completed</Badge>;
    }
    // For grouped orders, check if all items are returned
    if (hasActiveItems !== undefined) {
      return hasActiveItems ? (
        <Badge bg="warning">Active</Badge>
      ) : (
        <Badge bg="success">Returned</Badge>
      );
    }
    return isReturned ? (
      <Badge bg="success">Returned</Badge>
    ) : (
      <Badge bg="warning">Active</Badge>
    );
  };

  const shortenText = (text, maxLength = 20) => {
    if (!text) return "-";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  if (!transactions || transactions.length === 0) {
    return (
      <div className="text-center py-5">
        <p className="text-muted">No transactions found</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>#</th>
            <th style={{ textAlign: "center" }}>Order ID</th>
            <th style={{ textAlign: "center" }}>Date</th>
            <th style={{ textAlign: "center" }}>HN</th>
            <th style={{ textAlign: "center" }}>Name</th>
            <th style={{ textAlign: "center" }}>Mask</th>
            <th style={{ textAlign: "center" }}>Size</th>
            <th style={{ textAlign: "center" }}>Activity</th>
            <th style={{ textAlign: "center" }}>Due Date</th>
            <th style={{ textAlign: "center" }}>Qty</th>
            <th style={{ textAlign: "center" }}>Status</th>
            <th style={{ textAlign: "center" }}>Note</th>
            <th style={{ textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((order, index) => (
            <tr key={order.orderId || order.id}>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {index + 1}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.orderId || "-"}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.datetime}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.HN || "-"}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.firstname || ""} {order.lastname || ""}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.items && order.items.length > 0
                  ? order.items.map((item, i) => (
                      <div key={i}>{item.maskName || "-"}</div>
                    ))
                  : order.maskName || "-"}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.items && order.items.length > 0
                  ? order.items.map((item, i) => (
                      <div key={i}>{item.size || "-"}</div>
                    ))
                  : order.size || "-"}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {getActivityBadge(order.activity)}
                {order.activity === "Rent" && order.items && (
                  <div>
                    <small className="text-muted">
                      {order.items
                        .reduce((sum, item) => sum + (item.price || 0), 0)
                        .toLocaleString()}{" "}
                      THB
                    </small>
                  </div>
                )}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.activity === "Borrow" && order.dueDateFormatted
                  ? order.dueDateFormatted
                  : "-"}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.items && order.items.length > 0
                  ? order.items.map((item, i) => (
                      <div key={i}>{item.amount}</div>
                    ))
                  : order.amount}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {getStatusBadge(
                  order.isReturned,
                  order.activity,
                  order.hasActiveItems,
                )}
              </td>
              <td
                style={{ textAlign: "center", verticalAlign: "top", maxWidth: "150px" }}
                title={order.note || ""}
              >
                {shortenText(order.note, 10)}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "top" }}>
                {order.hasActiveItems && (
                  <Link
                    className="btn btn-success shadow btn-xs sharp mr-1"
                    to="#"
                    onClick={() => onReturn(order)}
                    title="Return All"
                  >
                    <i className="fa fa-undo"></i>
                  </Link>
                )}
                <Link
                  className="btn btn-primary shadow btn-xs sharp mr-1"
                  to="#"
                  onClick={() => onDownload(order)}
                  title="Download PDF"
                >
                  <i className="fa fa-download"></i>
                </Link>
                <Link
                  className="btn btn-info shadow btn-xs sharp mr-1"
                  to="#"
                  onClick={() => onEdit(order)}
                  title="Edit"
                >
                  <i className="fa fa-pencil"></i>
                </Link>
                <Link
                  className="btn btn-danger shadow btn-xs sharp"
                  to="#"
                  onClick={() => onDelete(order)}
                  title="Delete"
                >
                  <i className="fa fa-trash"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MaskTransactionItem;
